import React, { FormEvent, useContext } from "react";
import { useState } from "react";
import {
  Grid,
  Tab,
  Form,
  Input,
  Select,
  Button,
  Table,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { IProjectScope } from "../../../app/models/projectscope";
import TransmissionStore from "../../../app/stores/transmissionStore";
import ProjectScopeEditForm from "./ProjectScopeEditForm";

const ProjectScopeTab = () => {
  const transmissionStore = useContext(TransmissionStore);
  const {
    transmission,
    projectScopesByDescription,
    loadProjectScopes,
    createProjectScope,
    deleteProjectScope,
    selectedProjectScope,
    selectProjectScope,
    submitting,
    editMode,
    target,
  } = transmissionStore;

  const initialForm: IProjectScope = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    description: "",
    type: "",
    status: "",
    remark: "",
  };

  const [projectScope, setProjectScope] = useState<IProjectScope>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    description: "",
    type: "",
    status: "",
    remark: "",
  });

  const handleSubmit = () => {
    createProjectScope(projectScope)
      .then(() => loadProjectScopes(projectScope.projectId))
      .then(() => initialForm && setProjectScope(initialForm));
  };
  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectScope({ ...projectScope, [name]: value });
  };

  const type = [
    { key: "Scope", text: "Scope", value: "Scope" },
    { key: "Variation", text: "Variation", value: "Variation" },
  ];

  const status = [
    { key: "Not Started", text: "Not Started", value: "Not Started" },
    { key: "In Progress", text: "In Progress", value: "In Progress" },
    { key: "Completed", text: "Completed", value: "Completed" },
  ];

  return (
    <Tab.Pane>
      <Grid>
        <Grid.Column width={16}>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Field inline>
                <label>Description</label>
                <Input
                  onChange={handleInputChange}
                  name="description"
                  placeholder="Description"
                  value={projectScope.description}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Type</label>
                <Select
                  required
                  onChange={(e, { name, value }) => {
                    setProjectScope({ ...projectScope, [name]: value });
                  }}
                  options={type}
                  search
                  name="type"
                  placeholder="Type"
                  value={projectScope.type}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Status</label>
                <Select
                  required
                  onChange={(e, { name, value }) => {
                    setProjectScope({ ...projectScope, [name]: value });
                  }}
                  options={status}
                  search
                  name="Status"
                  placeholder="Status"
                  
                />
              </Form.Field>
              <Form.Field inline>
                <label>Remark</label>
                <Input
                  onChange={handleInputChange}
                  name="remark"
                  placeholder="Remark"
                  value={projectScope.remark}
                />
              </Form.Field>
            </Form.Group>
            <Form.Button
              loading={submitting}
              floated="right"
              positive
              type="submit"
              content="Add"
            />
          </Form>
        </Grid.Column>
      </Grid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {projectScopesByDescription.map((projectScope) => (
            <Table.Row key={projectScope.id}>
              <Table.Cell>{projectScope.description}</Table.Cell>
              <Table.Cell>{projectScope.type}</Table.Cell>
              <Table.Cell>{projectScope.status}</Table.Cell>
              <Table.Cell>{projectScope.remark}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    onClick={() => selectProjectScope(projectScope.id)}
                    size="mini"
                    content="Edit"
                    color="blue"
                  />
                  <Button
                    name={projectScope.id}
                    size="mini"
                    loading={target === projectScope.id && submitting}
                    onClick={(e) => deleteProjectScope(e, projectScope.id)}
                    content="Delete"
                    color="red"
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      {selectedProjectScope && editMode && <ProjectScopeEditForm />}
    </Tab.Pane>
  );
};

export default observer(ProjectScopeTab);
